import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import QueryString from "qs";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { ReqMethods, ghl } from "enums";
import env from "config";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
// import { AgencyContext } from '../../../context/Agency.context'

function GHL() {
  const navigate = useNavigate();
  // const [, update] = useAgencyInfo()
  const { search } = useLocation();
  const code = new URLSearchParams(search).get("code");
  const type = new URLSearchParams(search).get("type");
  const AppServices = useAppServices();
  const [Error, setError] = useState("");

  const searchParams = new URLSearchParams(document.location.search);
  // const agency = searchParams.get("state");
  // alert(agency);
  const associate = async (creds) => {
    const payload = {
      agency_ghl: {
        company_id: creds.companyId,
        access_token: creds.access_token,
        refresh_token: creds.refresh_token,
      },
    };
     

    var { response } = await AppServices.brand.update({ payload });
     
    setTimeout(() => {
      if (response) return setError("Agency Connect Successfully");
      if (!response) return setError("Something went wrong while integration, please try latter");
    }, 5000);
  };

  const getCreds = async () => {
    const payload = {
      method: ReqMethods.POST,
      path: ghl.APIs.oauth,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      payload: QueryString.stringify({
        client_id: env.GHL.CLIENT_ID,
        client_secret: env.GHL.CLIENT_SECRET,
        grant_type: "authorization_code",
        code,
        refresh_token: "",
      }),
    };
    //  
    const { response } = await AppServices.services.ghl.call_service({ payload });

    if (!response) return setError("Something went wrong while integration, please try latter");
     
    return response && associate(response.data);
  };
let pageLoad=true
  const onLoad = () => {
    if(pageLoad){

      getCreds();
      pageLoad=false
    }
  };

  useEffect(onLoad, []);

  return (
    <SoftBox>
      {!Error && <SoftBox>Integrating please wait...</SoftBox>}
      {Error && (
        <SoftBox>
          {Error}
          <SoftButton onClick={() => navigate(-2)}>Go Back</SoftButton>
        </SoftBox>
      )}
    </SoftBox>
  );
}

export default GHL;
